import setupInterceptors from '@/services/setupInterceptors';
import axios from 'axios';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var key = 'api_key=' + process.env.VUE_APP_API_KEY;
var appApisGTW = null;
if (!configuration['migration']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8086')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
export default {
  scan_attributes_objects: function scan_attributes_objects(data) {
    console.log('');
    return appApisGTW.post('/migrate_typesense/scan_attributes_objects?' + key, data).then(function (res) {
      return res.data;
    }).catch(function (err) {
      console.error(err);
      throw err;
    });
  }
};